import styled from 'styled-components';
import Theme from 'Theme';

const minSizeScreen = '431px';

export const Main = styled.main`
    margin-top: 120px;
    position: relative;
    overflow: hidden;
    height: calc(100vh - 120px);

    &:before {
        width: 100%;
        height: 100%;
        content: '';
        position: fixed;
        bottom: 0;
        left: 0;
        background-color: ${Theme.colorLightBgCommunication};
    }

    & > div {
        position: relative;
    }

    @media (max-width: 768px) {
        margin-top: 60px;
        height: calc(100vh - 60px);
        overflow: visible;
    }
`;

export const WhatsAppContainer = styled.div`
    display: flex;
    height: 100%;
    background-color: #f0f2f5;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    margin: 0 auto;
    touch-action: manipulation;
    @media (max-width: 768px) {
        flex-direction: column;
        height: calc(100vh - 140px);
        border-radius: 0;
    }
`;

export const SessionListPanel = styled.div`
    width: 350px;
    background-color: #ffffff;
    border-right: 1px solid #e9edef;
    display: flex;
    flex-direction: column;

    @media (max-width: 768px) {
        width: 100%;
        height: ${(props) => (props.selectedSession ? '0' : '100%')};
        overflow: hidden;
        transition: height 0.3s ease;
    }
`;

export const SessionListHeader = styled.div`
    padding: 20px 16px;
    background-color: #e1e3e2ff;
    border-bottom: 1px solid #e9edef;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const SessionListTitle = styled.h2`
    color: #111b21;
    font-size: 19px;
    font-weight: 600;
    margin: 0;
`;

// Chat Panel Styles
export const ChatPanel = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    background-color: #e1e3e2ff;
    position: relative;
    touch-action: manipulation;

    @media (max-width: 768px) {
        display: ${(props) => (props.selectedSession ? 'flex' : 'none')};
        height: 100%;
    }
`;

export const ChatHeader = styled.div`
    background-color: #f0f2f5;
    border-bottom: 1px solid #e9edef;
    padding: 16px 20px;
    display: flex;
    align-items: center;
    gap: 12px;
    min-height: 70px;
`;

export const BackButton = styled.button`
    background: none;
    border: none;
    color: #54656f;
    cursor: pointer;
    padding: 8px;
    border-radius: 50%;
    display: none;

    @media (max-width: 768px) {
        display: ${(props) => (props.selectedSession ? 'block' : 'none')};
    }

    &:hover {
        background-color: rgba(84, 101, 111, 0.1);
    }
`;

export const ChatAvatar = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #075e54;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: bold;
    font-size: 16px;
`;

export const ChatHeaderInfo = styled.div`
    flex: 1;
`;

export const ChatHeaderName = styled.div`
    font-weight: 600;
    color: #111b21;
    font-size: 16px;
`;

export const ChatHeaderStatus = styled.div`
    font-size: 13px;
    color: #667781;
`;

export const WelcomeScreen = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #f8f9fa;
    color: #41525d;
    text-align: center;
    padding: 40px;
`;

export const WelcomeIcon = styled.div`
    width: 80px;
    height: 80px;
    border: 2px solid #d1d7db;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
    font-size: 32px;
    color: #d1d7db;
`;

export const WelcomeTitle = styled.h3`
    font-size: 32px;
    font-weight: 300;
    margin: 0 0 12px 0;
    color: #41525d;
`;

export const WelcomeSubtitle = styled.p`
    font-size: 14px;
    color: #667781;
    line-height: 20px;
    margin: 0;
    max-width: 400px;
`;

export const SessionItem = styled.div`
    padding: 12px 16px;
    cursor: pointer;
    border-bottom: 1px solid #f0f2f5;
    background-color: ${(props) => (props.selected ? '#f0f2f5' : 'transparent')};
    transition: background-color 0.15s ease;

    &:hover {
        background-color: #f5f6f6;
    }
`;

export const SessionItemHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 6px;
`;

export const SessionName = styled.div`
    font-weight: 500;
    color: #111b21;
    font-size: 16px;
`;

export const SessionTime = styled.div`
    font-size: 12px;
    color: #667781;
`;

export const SessionPreview = styled.div`
    font-size: 14px;
    color: #667781;
    line-height: 18px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
`;

export const StatusChip = styled.span`
    display: inline-block;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 500;
    background-color: ${(props) => props.color || '#e9edef'};
    color: ${(props) => props.textColor || '#111b21'};
    margin-top: 4px;
`;

export const SearchContainer = styled.div`
    padding: 12px 16px;
    background-color: #f0f2f5;
    border-bottom: 1px solid #e9edef;
`;

export const SearchInput = styled.input`
    width: 100%;
    padding: 8px 16px;
    border: none;
    border-radius: 20px;
    background-color: #ffffff;
    font-size: 14px;
    outline: none;

    &::placeholder {
        color: #667781;
    }
`;

export const SessionList = styled.div`
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-y: contain;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.2);
        border-radius: 3px;
    }

    @media (max-width: 768px) {
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        transform: translateZ(0);

        &::-webkit-scrollbar {
            display: none;
        }

        /* Force hardware acceleration for better mobile performance */
        will-change: scroll-position;
        backface-visibility: hidden;
        perspective: 1000;
    }
`;

//./images/grupoaltum.png
export const ChatMessages = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 20px;
    background-image: url("data:image/svg+xml,%3Csvg width='260' height='260' viewBox='0 0 260 260' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23f0f0f0' fill-opacity='0.15'%3E%3Cpolygon points='20,60 50,30 50,100 80,70 80,140 110,110 110,180 140,150 140,220 170,190 170,260 200,230 200,300 230,270 230,340 260,310 260,380'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-y: contain;
    scroll-behavior: smooth;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.2);
        border-radius: 3px;
    }

    @media (max-width: 768px) {
        padding: 10px;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        transform: translateZ(0);

        &::-webkit-scrollbar {
            display: none;
        }

        /* Force hardware acceleration for better mobile performance */
        will-change: scroll-position;
        backface-visibility: hidden;
        perspective: 1000;
    }
`;

export const EmptyState = styled.div`
    text-align: center;
    padding: 40px 20px;
    color: #667781;
`;

export const FilterContainer = styled.div`
    padding: 12px 16px;
    background-color: #ffffff;
    border-bottom: 1px solid #e9edef;
    display: flex;
    gap: 8px;
    align-items: center;
`;

export const FilterSelect = styled.select`
    padding: 8px 12px;
    border: 1px solid #e9edef;
    border-radius: 8px;
    background-color: #ffffff;
    font-size: 14px;
    color: #111b21;
    outline: none;

    &:focus {
        border-color: #00a884;
    }
`;

export const ActionButton = styled.button`
    background: none;
    border: none;
    color: #54656f;
    cursor: pointer;
    padding: 8px;
    border-radius: 50%;

    &:hover {
        background-color: rgba(84, 101, 111, 0.1);
    }
`;

export const NewChatButton = styled.button`
    background-color: #00a884;
    color: white;
    border: none;
    border-radius: 50%;
    width: 56px;
    height: 56px;
    position: absolute;
    bottom: 20px;
    right: 20px;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    font-size: 24px;

    &:hover {
        background-color: #008069;
    }
`;

export const PaginationContainer = styled.div`
    padding: 12px 16px;
    background-color: #ffffff;
    border-top: 1px solid #e9edef;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const PaginationButton = styled.button`
    padding: 8px 16px;
    border: 1px solid #e9edef;
    background-color: ${(props) => (props.disabled ? '#f5f6f6' : '#ffffff')};
    color: ${(props) => (props.disabled ? '#b5bcc2' : '#111b21')};
    border-radius: 6px;
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    font-size: 14px;

    &:hover {
        background-color: ${(props) => (props.disabled ? '#f5f6f6' : '#f5f6f6')};
    }
`;

export const PaginationInfo = styled.span`
    font-size: 14px;
    color: #667781;
`;
